import { render, staticRenderFns } from "./UkModal.vue?vue&type=template&id=30c7b367&"
import script from "./UkModal.vue?vue&type=script&lang=js&"
export * from "./UkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c7b367')) {
      api.createRecord('30c7b367', component.options)
    } else {
      api.reload('30c7b367', component.options)
    }
    module.hot.accept("./UkModal.vue?vue&type=template&id=30c7b367&", function () {
      api.rerender('30c7b367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/UkModal.vue"
export default component.exports